import { useState } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Select,
  FormControl,
  IconButton,
  Checkbox,
  FormControlLabel,
  Alert,
  Typography,
} from "@mui/material";
import {
  Visibility,
  VisibilityOff,
  Lock,
  Email,
  ArrowDropDown,
} from "@mui/icons-material";


// import uae from "/Images/uae.jpg";
// import ValidationAlert from "../../component/Alerts/ValidationAlert";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { login } from "../../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { forgotpassword, getdefaulttaglist, resetpassword } from "../../redux/services/authService";
import { decrypt, encrypt } from "../../redux/services/encryptionUtils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Customer_Port } from "../../config";
import Loader from "../../Components/Loader/Loader";



function EmailLogin({ onRegisterClick }) {
  const [isLoading, setIsLoading] = useState(false);
  const [stop, setStop] = useState(false);
  const [error1, setError1] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [warning, setWarning] = useState(false);
  const [warningData, setWarningData] = useState({});
  const [country, setcountry] = useState([])
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");      // "7E76A1CB-CE2F-4761-BB2E-89940BDBAB94"
  const entityId = searchParams.get("entityid");

  useEffect(() => {
    if (token && entityId) {
    const showResetPasswordAlert = async () => {
  const { value: formValues } = await MySwal.fire({
    title: "Reset Password",
    html: `
      <div class="password-input-container">
        <input type="password" id="newPassword" class="password-swal-input" placeholder="New Password" maxlength="30">
        <span class="password-eye-icon password-open-eye" data-target="newPassword">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/>
          </svg>
        </span>
        <span class="password-eye-icon password-close-eye" data-target="newPassword" style="display:none;">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/>
          </svg>
        </span>
      </div>

      <div class="password-input-container">
        <input type="password" id="confirmPassword" class="password-swal-input" placeholder="Confirm Password" maxlength="30">
        <span class="password-eye-icon password-open-eye" data-target="confirmPassword">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/>
          </svg>
        </span>
        <span class="password-eye-icon password-close-eye" data-target="confirmPassword" style="display:none;">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555">
            <path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/>
          </svg>
        </span>
      </div>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: "Submit",
    cancelButtonText: "Close",
    reverseButtons: true,
    customClass: {
      confirmButton: "next-btn2",
    },

    preConfirm: () => {
      const newPassword = document.getElementById("newPassword").value;
      const confirmPassword = document.getElementById("confirmPassword").value;

      if (!newPassword) {
        Swal.showValidationMessage("New Password is required");
        return false;
      }

      if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/.test(newPassword)) {
        Swal.showValidationMessage("Password must be at least 6 characters long and include at least one letter, one number, and one special character.");
        return false;
      }

      if (!confirmPassword) {
        Swal.showValidationMessage("Confirm Password is required");
        return false;
      }

      if (newPassword !== confirmPassword) {
        Swal.showValidationMessage("Passwords do not match");
        return false;
      }

      return { newPassword, confirmPassword };
    },

    didOpen: () => {
      // Setup toggle functionality
      document.querySelectorAll(".password-eye-icon").forEach((icon) => {
        icon.addEventListener("click", function () {
          const targetId = this.getAttribute("data-target");
          const input = document.getElementById(targetId);

          const isOpen = this.classList.contains("password-open-eye");

          if (isOpen) {
            // show text
            input.type = "text";
            this.style.display = "none";
            document.querySelector(`.password-close-eye[data-target="${targetId}"]`).style.display = "block";
          } else {
            // hide text
            input.type = "password";
            this.style.display = "none";
            document.querySelector(`.password-open-eye[data-target="${targetId}"]`).style.display = "block";
          }
        });
      });
    },
  });

  if (formValues) {
    try {
      const encryptedPassword = await encrypt(formValues.newPassword);

      const postData = {
        token: token,
        entityId: entityId,
        newPassword: encryptedPassword,
      };

      const response = await resetpassword(postData);

      if (response.status === "Success") {
        await MySwal.fire("Success", "Password has been reset successfully!", "success");
      } else {
        await MySwal.fire("Error", response.message || "Failed to reset password", "error");
      }
    } catch (err) {
      console.error(err);
    }
  }
};


      showResetPasswordAlert();
    }
  }, [token, entityId]);


  const { loading, error, user } = useSelector((state) => state.auth);
  const navigate = useNavigate()
  const dispatch = useDispatch();

  const warningOpen = () => setWarning(true);
  const warningClose = () => setWarning(false);



  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const response = await getdefaulttaglist({ TagId: 8, BE: 1, languageId: 1 })

        if (response?.status === "Success") {

          const data = JSON.parse(response?.result)

          setcountry(data)


        }
      } catch (error) {

      }
    }
    fetchCountry()

  }, [])


  useEffect(() => {
    const savedCredentials = localStorage.getItem("rememberedCredentialsGSGCustomer");
    if (savedCredentials) {
      try {
        const creds = JSON.parse(savedCredentials);
        if (creds.loginName && creds.password) {

          setPassword(decrypt(creds.password));
          setEmail(creds.loginName)
          setRememberMe(true);
        } else {
          // If stored creds are incomplete, reset the state.
          creds.password({ loginName: "", password: "" });
        }
      } catch (error) {
        console.error("Error parsing stored credentials:", error);
        localStorage.removeItem("rememberedCredentialsGSGCustomer");
        setPassword("");
        setEmail("")
      }
    } else {

      setPassword("");
      setEmail("")
    }
  }, []);
  const LoginEmail = async (e) => {

    e.preventDefault();
    const newErrors = {};
    // Validate fields
    if (!email) { setError1("Login Name is required"); return }
    if (!password) { setError1("Password is required"); return }


    try {
      setIsLoading(true);
      setError1(null);

      const encryptedPassword = await encrypt(password)
      const submitData = {
        EntityId: selectedCountry,
        ChannelId: 1,
        Password: encryptedPassword,
        LoginName: email
      };

      const showWarning = (message, type) => {
        warningOpen();
        setWarningData({ message, type });
      };
      dispatch(login({ email: submitData.LoginName, password: submitData.Password, entityId: submitData?.EntityId ?? 1, rememberMe: rememberMe }));
      // const response = await loginLogin(submitData);
      //  if (response?.status === "Success") {

      //   localStorage.setItem(
      //     "SangGSGAccessToken",
      //     JSON.parse(response?.result?.accessToken)
      //   );
      //   localStorage.setItem(
      //     "SangGSGRefreshToken",
      //     JSON.parse(response?.result?.refreshToken)
      //   );
      //   localStorage.setItem("GSGUserData", response?.result?.userData);
      //   localStorage.setItem(
      //     "GSGEntity", 
      //     JSON.stringify({
      //       Company: 1,
      //       entityId: 1
      //     })
      //   );

      //    if (rememberMe) {

      //     localStorage.setItem("rememberedCredentialsGSG", JSON.stringify({ loginName: email, password: password }));
      //   } else {


      //     localStorage.removeItem("rememberedCredentialsGSG");
      //   }

      //   showWarning(response?.message, "success");
      //   navigate("/home");
      // }



    } catch (err) {

      setError1(err.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');
    if (accessToken && refreshToken) {

      // Store user data in localStorage for persistence
      if (user && user?.userData) {
        localStorage.setItem('userData', JSON.stringify(user.userData));
        localStorage.setItem('authToken', user.token || 'authenticated');
      }
      // Navigate to home and replace history to prevent back navigation to login
      navigate('/home', { replace: true });
    }
    else {
      localStorage.removeItem('userData');
      localStorage.removeItem('authToken');
      localStorage.removeItem("accessToken")
      localStorage.removeItem('refreshToken');
    }
  }, [user, navigate]);

  // -----forgot password -----------

  const MySwal = withReactContent(Swal);

  const handleForgotPassword = async () => {
    const { value: loginName } = await MySwal.fire({
      title: "Forgot Password",
      input: "text",
      inputLabel: "Enter your login name",
      inputPlaceholder: "Login name",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Close",
      reverseButtons: true,
      customClass: {
        confirmButton: "next-btn2",
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please enter your login name";
        }
      },

      // 👇 Resize the input when SweetAlert opens
      didOpen: () => {
        const input = document.querySelector(".swal2-input");
        if (input) {
          input.style.fontSize = "14px";         // smaller font
          input.style.height = "38px";           // shorter height
          input.style.width = "60%";             // reduce width (optional)
          input.style.margin = "0 auto";         // center input
          input.style.display = "block";         // ensure centered
          input.style.borderRadius = "8px";      // smooth corners
          input.style.padding = "6px 10px";      // adjust padding
        }
      },
    });

    if (loginName) {
      try {
        setStop(true);
        const postData = {
          loginName: loginName,
          link: Customer_Port,
          entityId: selectedCountry,
        };
        const response = await forgotpassword(postData);

        if (response.status === "Success") {
          MySwal.fire("Success", "Password reset link sent to your email!", "success");
        } else {
          MySwal.fire("Error", response.message || "Failed to send reset link", "error");
        }
      } catch (error) {
       
      } finally {
        setStop(false);
      }
    }
  };




  return (
    <div className="login-form-container">
      <h1 className="login-title">User Login</h1>

      {error1 && <Alert severity="error" className="error-alert">{error1}</Alert>}

      <form onSubmit={LoginEmail} className="login-form">
        {/* Country Selector */}
        <FormControl fullWidth className="country-selector">
          <Select
            value={selectedCountry}
            onChange={(e) => { setSelectedCountry(e.target.value); setError1(null) }}
            IconComponent={ArrowDropDown}
            className="custom-select"
            displayEmpty
            renderValue={(value) => {
              const count = country.find(c => c.Id === value);
              return (
                <div className="selected-country">
                  <img
                    src={"./Images/uae.jpg"}
                    alt={count?.Name}
                    className="country-flag"
                  />
                  <span>{count?.Name}</span>
                </div>
              );
            }}
          >
            {country.map((country) => (
              <MenuItem key={country.Name} value={country.Id}>
                <div className="country-option">
                  <img
                    src={"./Images/uae.jpg"}
                    alt={country.Name}
                    className="country-flag"
                  />
                  <span>{country.Name}</span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Username */}
        <TextField
          fullWidth
          placeholder="Username"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setError1(null) }}
          className="custom-input username-input"
          InputProps={{
            startAdornment: <Email className="input-icon" />,
          }}
          variant="outlined"
        />

        {/* Password */}
        <TextField
          fullWidth
          placeholder="Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="custom-input password-input"
          InputProps={{
            startAdornment: <Lock className="input-icon" />,
            endAdornment: (
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                className="eye-icon"
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
          variant="outlined"
        />

        {/* Remember Me */}
        <FormControlLabel
          control={<Checkbox className="remember-checkbox" checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)} />}
          label="Remember me"
          className="remember-me"
        />

        {/* Buttons */}
        <div className="button-container">
          <Button
            type="submit"
            variant="contained"
            disabled={isLoading}
            className="login-button"
            fullWidth
          >
            {isLoading ? "Logging in..." : "LOGIN"}
          </Button>

          <Button
            variant="outlined"
            className="register-button"
            fullWidth
            onClick={(e) => {
              e.preventDefault();
              onRegisterClick()
              // Add register navigation here
            }}
          >
            REGISTER
          </Button>
          <Typography
            variant="body2"
            sx={{ color: "#686767ff", cursor: "pointer", textAlign: 'end' }}
            onClick={handleForgotPassword}
          >
            Forgot password?
          </Typography>
        </div>
      </form>
      {stop && <Loader />}
      {/* <ValidationAlert
            open={warning}
            handleClose={warningClose}
            data={warningData}
          /> */}
    </div>
  );
}

export default EmailLogin;